/* eslint-disable no-loop-func */
import { memo, useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import SendToModal from "js/Component/SendToModal";
import { fetchOrganizationDevices } from "js/Api/index";
import { fetchResultDetails } from "js/Api/forms";
import moment from 'moment';
import dayjs from "dayjs";
import { utcToLocal } from "js/helpers/date";
import JSZip from "jszip";
import { saveAs } from "file-saver";
import Loader from "js/Component/Loader";

const ExportResponse = (props) => {
    const { org, visible, onClose, responsesList } = props;

    const [file_type, setfile_type] = useState("CSV")
    const [FromDate, setFromDate] = useState(null)
    const [ToDate, setToDate] = useState(null)

    const handleDateChange = (date, field) => {
        if (field === "startTime") {
            setFromDate(date);
        } else if (field === "endTime") {
            setToDate(date);
        }
    };

    const [items, setItems] = useState([]);
    const [itemPicker, setItemPicker] = useState(false);
    const [searchQuery, setSearchQuery] = useState("");
    const [selectAll, setSelectAll] = useState(false);
    const [selectedItems, setSelectedItems] = useState([]);
    const [displayItems, setDisplayItems] = useState([]);
    const [isLoadingData, setIsLoadingData] = useState(false);

    const fetchItems = async () => {
        setIsLoadingData(true);
        try {
            const response = await fetchOrganizationDevices(org.code, false);
            if (response.success) {
                let filteredDevices = response.data.filter(mainItem => {
                    return responsesList.some(filterItem => filterItem.deviceId === mainItem.id);
                });
                setItems(filteredDevices);
            } else {
                console.error("Failed to fetch devices:", response.error);
            }
            setIsLoadingData(false);
        } catch (error) {
            console.error(`Failed to fetch devices:`, error);
        }
    };

    useEffect(() => {
        const uniqueIds = new Set(responsesList.map(item => item.deviceId));
        if (uniqueIds.size === 1 && visible) {
            fetchItems();
        }
    }, [visible]);

    useEffect(() => {
        const uniqueIds = new Set(responsesList.map(item => item.deviceId));
        if (uniqueIds.size === 1 && items.length === 1) {
            setSelectAll(true);
            setSelectedItems(filteredItems.map((item) => item.id));

            handleConfirm();
        }
    }, [items]);

    useEffect(() => {
        const uniqueIds = new Set(responsesList.map(item => item.deviceId));
        if (uniqueIds.size === 1) {

        }
        else {
            fetchItems();
        }
    }, [itemPicker]);

    const handleCancel = () => {
        setItemPicker(false);
        setSearchQuery("");
        setSelectAll(false);
    };

    const onOkPress = async () => {
        if (selectedItems.length === 0)
            alert("Please select at least one device")
        else {
            setIsLoadingData(true);
            let start_utc = moment.utc(FromDate);
            let end_utc = moment.utc(ToDate);

            let filter_resp = responsesList.filter(mainItem => {
                return selectedItems.some(filterItem => mainItem.deviceId === filterItem);
            });

            if (FromDate !== null)
            {
                filter_resp = filter_resp.filter(a => dayjs(new Date(a.createdAt)).isAfter(dayjs(new Date(start_utc.format("YYYY-MM-DD HH:MM")))))
            }

            if (ToDate !== null) {
                filter_resp = filter_resp.filter(a => dayjs(new Date(a.createdAt)).isBefore(dayjs(new Date(end_utc.format("YYYY-MM-DD HH:MM")))))

            }

            if (filter_resp.length > 0) {
                const responseDetails = []

                for (var i = 0; i < filter_resp.length; i++) {
                    const response = await fetchResultDetails(filter_resp[i].id);
                    if (response?.success && response?.data) {
                        var obj = { id: filter_resp[i].id, date: filter_resp[i].createdAt, deviceId: filter_resp[i].deviceId, device_name: filter_resp[i].name, form_name: filter_resp[i].formName, ques: response.data }
                        responseDetails.push(obj)
                    }
                }
                if (responseDetails.length > 0) {
                    const zip = new JSZip();
                    for (var m = 0; m < selectedItems.length; m++) {

                        const jsonData = responseDetails.filter(a => a.deviceId === selectedItems[m]).sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))

                        const csvContent = transformQuestionsToCSV(jsonData);
                        //const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
                        //saveAs(blob, "questions.csv");

                        //const file = makeCSV(jsonData, `responses_${jsonData[0].device_name}.csv`);
                        zip.file(`responses_${jsonData[0].device_name}.csv`, csvContent);
                    }
                    setIsLoadingData(false);
                    const content = await zip.generateAsync({ type: "blob" });
                    saveAs(content, "responses.zip");
                }
            }
            else {
                setIsLoadingData(false);
                alert("No response found for the selected search.")
            }
        }
    };

    const transformQuestionsToCSV = (data) => {
        const dates = [...new Set(data.map(item => item.date))];
        const header_dates = [...new Set(data.map(item => item.form_name + " - " + dayjs(utcToLocal(item.date)).format("DD/MM/YYYY h:mma")))];
        const header = ["Question", ...header_dates];

        const dateQuestionMap = {};

        data.forEach(response => {
            const dateKey = response.date; // yyyy-MM-dd
            const optionToQuestionMap = {};

            const rows = [];

            // Main questions
            const mainQuestions = response.ques
                .filter(q => q.refFieldOption === null)
                .map(main => {
                    const answer = main.freeTextResponse !== "" && main.freeTextResponse !== null
                        ? main.freeTextResponse
                        : main.answers.map(a => a.fieldOption).join(" | ");

                    // Register option IDs for sub-questions
                    main.answers.forEach(a => {
                        optionToQuestionMap[a.id] = main.id;
                    });

                    return {
                        id: main.id,
                        question: main.fieldName,
                        answer,
                        subQuestions: []
                    };
                });

            // Sub-questions
            response.ques
                .filter(q => q.refFieldOption !== null)
                .forEach(sub => {
                    const parentId = optionToQuestionMap[sub.refFieldOption];
                    const parent = mainQuestions.find(m => m.id === parentId);

                    const answer = sub.freeTextResponse !== "" && sub.freeTextResponse !== null
                        ? sub.freeTextResponse
                        : sub.answers.map(a => a.fieldOption).join(" | ");

                    if (parent) {
                        parent.subQuestions.push({
                            id: sub.id,
                            question: sub.fieldName,
                            answer
                        });
                    }
                });

            // Flatten into rows
            mainQuestions.forEach(m => {
                rows.push({ question: m.question, answer: m.answer });
                m.subQuestions.forEach(sq => {
                    rows.push({ question: sq.question, answer: sq.answer });
                });
            });

            dateQuestionMap[dateKey] = rows;
        });

        // Collect all unique questions across all dates
        const allQuestions = [
            ...new Set(
                Object.values(dateQuestionMap).flatMap(rows =>
                    rows.map(r => r.question)
                )
            )
        ];

        const rows = allQuestions.map(question => {
            const row = [question];
            dates.forEach(date => {
                const entry = dateQuestionMap[date]?.find(r => r.question === question);
                row.push(entry ? entry.answer : "");
            });
            return row;
        });

        // CSV content
        const csvContent = [header, ...rows]
            .map(row => row.join(file_type === "CSV" ? "," : "\t"))
            .join("\n");

        return csvContent;
    };

    const handleSelectAll = () => {
        setSelectAll(!selectAll);
        if (!selectAll) {
            setSelectedItems(filteredItems.map((item) => item.id));
        } else {
            setSelectedItems([]);
        }
    };

    const handleItemSelect = (itemId) => {
        setSelectedItems((prevSelectedItems) =>
            prevSelectedItems.includes(itemId)
                ? prevSelectedItems.filter((id) => id !== itemId)
                : [...prevSelectedItems, itemId]
        );
    };

    const handleConfirm = () => {
        setItemPicker(false);
        const selectedDevices = items.filter((item) =>
            selectedItems.includes(item.id)
        );
        setDisplayItems(selectedDevices.map((device) => device.name));
    };

    const filteredItems = items.filter(
        (item) =>
            item.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
            (item.serialNo &&
                item.serialNo.toLowerCase().includes(searchQuery.toLowerCase()))
    );

    const displaySelectedItems =
        displayItems.length > 0
            ? displayItems.slice(0, 5).join(", ") +
            (displayItems.length > 5 ? "..." : "")
            : null;

    if (!visible) return null;

    return (
        <>
            <div className="modal" tabIndex={"-1"} role="dialog">
                <div className="modal-dialog" role="document">
                    <div className="modal-content" style={{ minWidth: "700px" }}>

                        <div class="modal-header">
                            <h1 class="modal-title">Export filtered responses</h1>
                            <button className="close-button" style={{ alignSelf: "flex-end" }} onClick={onClose} > &times; </button>
                        </div>
                        <div className="modal-body">
                            <form className="contact-form">
                                <div className="form-group">
                                    <label htmlFor="body"><strong>File Format</strong></label>
                                    <div>
                                        <label htmlFor="all_policy_group" style={{ marginRight: 70 }}>
                                            <input type="radio" name="sendTo" id="CSV" style={{ marginRight: 5, accentColor: "#007bff" }}
                                                value="CSV" checked={file_type === "CSV"}
                                                onChange={() => { setfile_type("CSV"); }} />
                                            CSV
                                        </label>
                                        <label htmlFor="all_policy_group" style={{ marginRight: 70 }}>
                                            <input type="radio" name="sendTo" id="TAB" style={{ marginRight: 5, accentColor: "#007bff" }}
                                                value="CSV" checked={file_type === "TAB"}
                                                onChange={() => { setfile_type("TAB"); }} />
                                            Tab-delimited
                                        </label>
                                    </div>
                                </div>
                                <div className="form-group">
                                    <table>
                                        <tr>
                                            <td style={{ border: "0px" }}>Start Time</td>
                                            <td style={{ border: "0px" }}>End Time</td>
                                        </tr>
                                        <tr>
                                            <td style={{ border: "0px" }}>
                                                <DatePicker selected={FromDate} onChange={(date) => handleDateChange(date, "startTime")} popperPlacement="bottom-end"
                                                    showTimeSelect dateFormat="yyyy-MM-dd HH:mm" timeFormat="HH:mm" className="form-control" style={{ width: "200px" }} />
                                            </td>
                                            <td style={{ border: "0px" }}>
                                                <DatePicker selected={ToDate} onChange={(date) => handleDateChange(date, "endTime")} popperPlacement="bottom-end"
                                                    showTimeSelect dateFormat="yyyy-MM-dd HH:mm" timeFormat="HH:mm" className="form-control" style={{ width: "200px" }} />
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                                <div className="form-group">
                                    <div>
                                        <button class="export-btn" onClick={(e) => { e.preventDefault(); setItemPicker(true) }}>
                                            Select devices
                                        </button>
                                        <div style={{ marginTop: "10px" }}>{displaySelectedItems}</div>
                                    </div>
                                </div>
                            </form>
                            <div>
                                <button className="btn bg-white border border-dark text-dark px-4 py-2" onClick={onClose} > Cancel </button>&nbsp;&nbsp;
                                <button className="btn btn-dark text-white px-5 py-2" onClick={onOkPress} >  Export  </button>
                                {isLoadingData &&
                                    <>
                                        <div style={{ textAlign: "left", padding: "40px", display: "inline" }}>
                                            <Loader />
                                        </div>
                                    </>
                                }
                            </div>
                        </div>

                        <SendToModal visible={itemPicker} sendTo={"device"} title={"Devices"} searchPlaceholderText={"devices"} searchQuery={searchQuery}
                            filteredItems={filteredItems} selectedItems={selectedItems} selectAll={selectAll} tableTitle={"Select Devices"}
                            handleCancel={handleCancel} setSearchQuery={setSearchQuery} handleSelectAll={handleSelectAll} handleItemSelect={handleItemSelect}
                            handleConfirm={handleConfirm} isLoading={isLoadingData} />
                    </div>
                </div>
            </div>
        </>
    );
};

export default memo(ExportResponse);
